import Layout from '@/components/layout/Index';
// import ProcessSection from '@/components/sections/ProcessSection';
import ServicesHeader from '@/components/sections/ServicesHeader';
import ServicesSection from '@/components/sections/ServicesSection';
import Loader from '@/components/ui/Loader';
import { useServicesPage } from '@/hooks/useSanityData';
import { useEffect, useState } from 'react';

const Services = () => {
	const { isLoading, data } = useServicesPage();
	const [isContentReady, setIsContentReady] = useState(false);

	useEffect(() => {
		if (!isLoading && data) {
			const timer = setTimeout(() => {
				setIsContentReady(true);
			}, 300);

			return () => clearTimeout(timer);
		}
	}, [isLoading, data]);

	if (isLoading || !isContentReady) {
		return <Loader />;
	}

	return (
		<div className='flex flex-col w-full overflow-hidden'>
			<Layout>
				<main className='w-full'>
					<ServicesHeader />
					<section className='py-12 md:mx-auto bg-background rounded-t-3xl relative z-20 -mt-5 md:px-20.5'>
						<ServicesSection />
						{/* <ProcessSection /> */}
					</section>
				</main>
			</Layout>
		</div>
	);
};

export default Services;
